import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import { useSearchParams } from "react-router-dom";
import { showErrorMessage } from "../Shared/Toast";

function LocationMove() {
  const [searchParams] = useSearchParams();
  const selectedMoverID: any = searchParams.get("ID");
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [addEditObject, setAddEditObject] = useState<any>({
    MNVLocationMoveID: 0,
    MVLocationsID: 0,
    MNVVanTypeID: null,
    MNVMoverTypeID: null,
    Name: "",
    JobID: null,
    PTOrderBy: null,
    TypeOfMove: null,
    Distance: null,
    TotalTimeInHours: null,
    LatestPrice: null,
    LastUpdatedPriceDate: null,
  });
  const [screenListData, setScreenListData] = useState<any>([]);
  const [screenData, setScreenData] = useState<any>([]);

  useEffect(() => {
    getScreenListData();
    getScreenData();
  }, []);

  function getScreenListData() {
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL +
          "api/MNVLocationMove/MNVLocationMoveGetCompleteDataSetForForeignKeys"
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;

          var l_arrTypes = [
            { PID: 1, Name: "Driver" },
            { PID: 2, Name: "Helper" },
          ];
          l_oResponse.push(l_arrTypes);

          var l_arrTiers = [
            { PID: 1, Name: "1" },
            { PID: 2, Name: "2" },
            { PID: 3, Name: "3" },
          ];
          l_oResponse.push(l_arrTiers);

          setScreenListData(l_oResponse);
        }
        // setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function getScreenData() {
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL +
          "api/MNVLocationMove/MNVLocationMoveGetCompleteGridData"
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          l_oResponse = FilterJsonExactlyMatching(
            l_oResponse,
            "IsDeleted",
            false
          );
          // if (selectedMoverID && selectedMoverID > 0) {
          //   l_oResponse = FilterJsonExactlyMatching(
          //     l_oResponse,
          //     "MNVLocationMoveID",
          //     selectedMoverID
          //   );
          // }
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
          setScreenData(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    var IsOkay = true;
    if (!addEditObject.MVLocationsID || addEditObject.MVLocationsID == 0) {
      showErrorMessage("Please select Location");
      IsOkay = false;
    } else if (!addEditObject.MNVVanTypeID || addEditObject.MNVVanTypeID == 0) {
      showErrorMessage("Please select Van Type");
      IsOkay = false;
    } else if (
      !addEditObject.MNVMoverTypeID ||
      addEditObject.MNVMoverTypeID == 0
    ) {
      showErrorMessage("Please select Mover Type");
      IsOkay = false;
    } else if (!addEditObject.Name || addEditObject.Name == "") {
      showErrorMessage("Please enter Name");
      IsOkay = false;
    } else if (
      !addEditObject.JobID ||
      addEditObject.JobID == "" ||
      addEditObject.JobID == 0
    ) {
      showErrorMessage("Please select Job ID");
      IsOkay = false;
    } else if (
      !addEditObject.LastUpdatedPriceDate ||
      addEditObject.LastUpdatedPriceDate == ""
    ) {
      showErrorMessage("Please select Last Updated Price Date");
      IsOkay = false;
    }

    if (IsOkay == true) {
      saveScreenData();
    }
  }

  function saveScreenData() {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVLocationMoveID = addEditObject.MNVLocationMoveID;
    object.MVLocationsID = addEditObject.MVLocationsID;
    object.MNVVanTypeID = addEditObject.MNVVanTypeID;
    object.MNVMoverTypeID = addEditObject.MNVMoverTypeID;
    object.Name = addEditObject.Name;
    object.JobID = addEditObject.JobID;
    object.PTOrderBy = addEditObject.PTOrderBy;
    object.TypeOfMove = addEditObject.TypeOfMove;
    object.Distance = addEditObject.Distance;
    object.TotalTimeInHours = addEditObject.TotalTimeInHours;
    object.LatestPrice = addEditObject.LatestPrice;
    object.LastUpdatedPriceDate = addEditObject.LastUpdatedPriceDate;

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVLocationMove/MNVLocationMoveSave",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (l_response && l_response[0] && l_response[0].Status == 0) {
            showErrorMessage(l_response[0].Message);
          } else {
            setIsAddNew(0);
            getScreenData();
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVLocationMoveID = pid;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVLocationMove/MNVLocationMoveDeleteRecord",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          getScreenData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function RefreshLocationMoveData(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.JobID = pid;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/UpdateMNVLocationMoveData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          getScreenData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MVLocationsName")) {
        (
          document.getElementById(
            "imgSort" + "MVLocationsName"
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MNVVanTypeName")) {
        (
          document.getElementById(
            "imgSort" + "MNVVanTypeName"
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MNVMoverTypeName")) {
        (
          document.getElementById(
            "imgSort" + "MNVMoverTypeName"
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {isAddNew == 0 && (
        <>
          <div className="flex-d justify-btw mb-10">
            <span></span>
            <div className="flex-daj flex-gap10">
              <a
                className="link-btn btn-link-m"
                onClick={() => ClearAllFilters()}
              >
                Clear All Filters
              </a>
              <div className="flex-daj btn-start flex-gap10">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setAddEditObject({
                      MNVLocationMoveID: 0,
                      MVLocationsID: 0,
                      MNVVanTypeID: null,
                      MNVMoverTypeID: null,
                      Name: "",
                      JobID: null,
                      PTOrderBy: null,
                      TypeOfMove: null,
                      Distance: null,
                      TotalTimeInHours: null,
                      LatestPrice: null,
                      LastUpdatedPriceDate: null,
                    });
                    setIsAddNew(1);
                  }}
                >
                  Add New
                </a>
                <a
                  className="btn-primary flex-daj"
                  onClick={() => RefreshLocationMoveData(0)}
                >
                  Refresh Prices
                </a>
              </div>
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() =>
                  DownloadClientsDataInExcel("tbllocationmove", "Location Move")
                }
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="tbllocationmove">
              <thead>
                <tr>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Locations
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MVLocationsName")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() =>
                            LoadWithSelectedSort("MVLocationsName")
                          }
                          title={"Sort By Mover Type"}
                        >
                          <span id={"imgSort" + "MVLocationsName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Van Type
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MNVVanTypeName")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("MNVVanTypeName")}
                          title={"Sort By Base"}
                        >
                          <span id={"imgSort" + "MNVVanTypeName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Mover Type
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MNVMoverTypeName")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() =>
                            LoadWithSelectedSort("MNVMoverTypeName")
                          }
                          title={"Sort By User"}
                        >
                          <span id={"imgSort" + "MNVMoverTypeName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>Job ID</th>
                  <th>Order By</th>
                  <th>Type Of Move</th>
                  <th>Distance</th>
                  <th>Total Time In Hours</th>
                  <th>Latest Price</th>
                  <th className="td-xxxs">Action</th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td>{item.MVLocationsName}</td>
                          <td>{item.MNVVanTypeName}</td>
                          <td>{item.MNVMoverTypeName}</td>
                          <td>{item.JobID}</td>
                          <td className="text-right">{item.PTOrderBy}</td>
                          <td>{item.TypeOfMove}</td>
                          <td className="text-right">{item.Distance}</td>
                          <td className="text-right">
                            {item.TotalTimeInHours}
                          </td>
                          <td className="text-right">{item.LatestPrice}</td>
                          <td className="td-xxxs">
                            <div className="flex-daj gap-10">
                              <a
                                title="Refresh Job Price"
                                onClick={() =>
                                  RefreshLocationMoveData(item.JobID)
                                }
                              >
                                <img
                                  src="images/refresh-t.svg"
                                  width="16px"
                                  height="16px"
                                  alt="Refresh"
                                />
                              </a>

                              <a
                                onClick={() => {
                                  setIsAddNew(2);
                                  setAddEditObject({
                                    MNVLocationMoveID: item.MNVLocationMoveID,
                                    MVLocationsID: item.MVLocationsID,
                                    MNVVanTypeID: item.MNVVanTypeID,
                                    MNVMoverTypeID: item.MNVMoverTypeID,
                                    Name: item.Name,
                                    JobID: item.JobID,
                                    PTOrderBy: item.PTOrderBy,
                                    TypeOfMove: item.TypeOfMove,
                                    Distance: item.Distance,
                                    TotalTimeInHours: item.TotalTimeInHours,
                                    LatestPrice: item.LatestPrice,
                                    LastUpdatedPriceDate:
                                      item.LastUpdatedPriceDate,
                                  });
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: item.MNVLocationMoveID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20">
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">
                  Locations:
                </span>
                <select
                  className="input-field w-100"
                  value={addEditObject.MVLocationsID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MVLocationsID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Location</option>
                  {screenListData[0] &&
                    screenListData[0].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">Van Type:</span>
                <select
                  className="input-field w-100"
                  value={addEditObject.MNVVanTypeID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MNVVanTypeID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Van Type</option>
                  {screenListData[1] &&
                    screenListData[1].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">
                  Mover Type:
                </span>
                <select
                  className="input-field w-100"
                  value={addEditObject.MNVMoverTypeID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MNVMoverTypeID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Mover Type</option>
                  {screenListData[2] &&
                    screenListData[2].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Name:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Name}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Name: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Job ID:</span>
                <input
                  className="input-field w-100"
                  type="number"
                  value={addEditObject.JobID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      JobID: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Order By:</span>
                <input
                  className="input-field w-100"
                  type="number"
                  value={addEditObject.PTOrderBy}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      PTOrderBy: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Type Of Move:
                </span>
                <input
                  className="input-field w-100"
                  type="number"
                  value={addEditObject.TypeOfMove}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      TypeOfMove: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Distance:</span>
                <input
                  className="input-field w-100"
                  type="number"
                  value={addEditObject.Distance}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Distance: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Total Time In Hours:
                </span>
                <input
                  className="input-field w-100"
                  type="number"
                  value={addEditObject.TotalTimeInHours}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      TotalTimeInHours: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Latest Price:
                </span>
                <input
                  className="input-field w-100"
                  type="number"
                  value={addEditObject.LatestPrice}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      LatestPrice: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Last Updated Price Date:
                </span>
                <input
                  className="input-field w-100"
                  placeholder="Date"
                  type="date"
                  value={moment(addEditObject.LastUpdatedPriceDate).format(
                    "YYYY-MM-DD"
                  )}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      LastUpdatedPriceDate: moment(e.target.value).format(
                        "YYYY-MM-DD"
                      ),
                    }))
                  }
                />
              </div>
            </div>
            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default LocationMove;
